import { supabase } from './supabase';

export const debugStripeIntegration = async () => {
  console.log('🔍 Starting Stripe integration debug...');
  
  try {
    // Check if user is authenticated
    console.log('🔐 Checking user authentication...');
    const { data: { user }, error: userError } = await supabase.auth.getUser();
    
    if (userError) {
      console.error('❌ User authentication error:', userError);
      return { success: false, error: 'User authentication error', details: userError };
    }
    
    if (!user) {
      console.error('❌ User not authenticated - no user found');
      return { success: false, error: 'User not authenticated' };
    }
    
    console.log('✅ User authenticated:', user.id);

    // Get session
    console.log('🎫 Getting session...');
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    
    if (sessionError) {
      console.error('❌ Session error:', sessionError);
      return { success: false, error: 'Session error', details: sessionError };
    }
    
    if (!session) {
      console.error('❌ No active session found');
      return { success: false, error: 'No active session' };
    }
    
    console.log('✅ Session found, expires at:', session.expires_at);

    // Check environment variables
    console.log('🔧 Checking environment variables...');
    const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
    if (!anonKey) {
      console.error('❌ Missing VITE_SUPABASE_ANON_KEY');
      return { success: false, error: 'Missing environment variable: VITE_SUPABASE_ANON_KEY' };
    }
    console.log('✅ Environment variables OK');

    // Call debug function
    console.log('🚀 Calling debug-create-payment-intent function...');
    
    const functionCall = supabase.functions.invoke('debug-create-payment-intent', {
      body: {
        plan: 'premium',
        priceId: 'price_1RmFnwGG5dpuxsMKYJREqXTU',
        trialDays: 7
      },
      headers: {
        'Authorization': `Bearer ${session.access_token}`,
        'apikey': anonKey,
        'Content-Type': 'application/json'
      }
    });

    console.log('⏳ Waiting for function response...');
    const { data, error } = await functionCall;

    if (error) {
      console.error('❌ Debug function error:', error);
      console.error('❌ Error details:', JSON.stringify(error, null, 2));
      return { success: false, error: error.message || 'Function call failed', details: error };
    }

    console.log('✅ Debug function response:', data);
    return { success: true, data };

  } catch (error) {
    console.error('❌ Debug test caught error:', error);
    console.error('❌ Error stack:', error.stack);
    return { success: false, error: error.message || 'Unknown error', details: error };
  }
};

// Make debug function globally available immediately
if (typeof window !== 'undefined') {
  // Original async function
  window.debugStripeIntegration = debugStripeIntegration;
  
  // Wrapper function that handles the promise and logs results
  window.runDebug = async () => {
    console.log('🎬 Starting debug test...');
    try {
      const result = await debugStripeIntegration();
      console.log('🏁 Debug test completed:', result);
      return result;
    } catch (error) {
      console.error('💥 Debug test failed:', error);
      return { success: false, error: error.message };
    }
  };
  
  console.log('🔧 Debug functions loaded:');
  console.log('  - debugStripeIntegration() (returns Promise)');
  console.log('  - runDebug() (handles Promise and logs result)');
  console.log('💡 Recommended: Use runDebug() for easier testing');
  
  // Also add a simple test function
  window.testDebug = () => {
    console.log('🧪 Test function working!');
    return 'Debug utilities are loaded';
  };
}

// Auto-execute a simple test to confirm loading
console.log('🚀 debugStripe.js module loaded successfully');
